<template>
  <section class="section">
    <slot />
  </section>
</template>

<script setup>

</script>
